/** Masonry slot names for the 11-tile About collage layout (repeats for every full group). */
export const ABOUT_SELFIE_COLLAGE_SLOTS = [
  "slot-01",
  "slot-02",
  "slot-03",
  "slot-04",
  "slot-05",
  "slot-06",
  "slot-07",
  "slot-08",
  "slot-09",
  "slot-10",
  "slot-11",
];

/**
 * @typedef {{ id: string | number, imageKey: string, url?: string }} AboutSelfie
 */
